module.exports = __webpack_public_path__ + "static/img/group23.6e2769a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group23.jpg
// module id = oxWf
// module chunks = 0